import { CommonModule, NgOptimizedImage } from '@angular/common';
import { Injector, NgModule } from '@angular/core';
import { createCustomElement } from '@angular/elements';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DcBadgeModule } from '@datachain/ui-sdk/components/app-badge';
import { DcButtonModule } from '@datachain/ui-sdk/components/app-button';
import { DcPageModule } from '@datachain/ui-sdk/components/app-page';
import { DcPanelModule } from '@datachain/ui-sdk/components/app-panel';
import { DcAvatarModule } from '@datachain/ui-sdk/components/avatar';
import { DcBreadcrumbModule } from '@datachain/ui-sdk/components/breadcrumb';
import { DcNavigateDirectiveModule } from '@datachain/ui-sdk/directives';
import { DcArrayPipeModule } from '@datachain/ui-sdk/pipes';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { DxDataGridModule } from 'devextreme-angular';

import { MaterialModule } from '../ui/material.module';
import { UiModule } from '../ui/ui.module';
import { RankingActionPopupComponent } from './components/ranking-action-popup/ranking-action-popup.component';
import { RankingListComponent } from './components/ranking-list/ranking-list.component';
import { RankingAdapter } from './ranking.adapter';
import {
	RankingEffects,
	rankingReducer,
	RankingSelector,
	RankingState,
} from './store';

@NgModule({
	declarations: [RankingListComponent, RankingActionPopupComponent],
	imports: [
		CommonModule,
		ReactiveFormsModule,
		UiModule,
		MaterialModule,
		StoreModule.forFeature(RankingState.key, rankingReducer),
		EffectsModule.forFeature([RankingEffects]),
		DxDataGridModule,
		NgOptimizedImage,
		FormsModule,
		DcPageModule,
		DcPanelModule,
		DcArrayPipeModule,
		DcBadgeModule,
		DcAvatarModule,
		DcNavigateDirectiveModule,
		DcBreadcrumbModule,
		DcButtonModule,
	],
	providers: [RankingAdapter, RankingSelector],
})
export class RankingModule {
	public constructor(private readonly injector: Injector) {
		const rankingListCmpElement = createCustomElement(RankingListComponent, {
			injector,
		});
		customElements.define('app-ranking-list', rankingListCmpElement);
	}
}
